import styled from '@emotion/styled';
import Cookies from 'js-cookie';
import ReactPixel from 'react-facebook-pixel';

const Cta:React.FC<any> = () => {
  const handleAppStore = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://apps.apple.com/kr/app/%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%9D%B8%ED%99%94%EA%B5%AC%EB%8F%85/id1619040733", "_blank")
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'appStore',
      "city": "KR",
      "gender" : "female"
    })
    
    // await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
  }

  const handleGoogle = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://play.google.com/store/apps/details?id=com.photypeta.photypetaApp", "_blank");
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'googlePlayStore',
      "city": "KR",
      "gender" : "female"
    })
  }

  return (
    <Container>
      <Title>지금 시작하세요</Title>
      <SmallText>
        지금 앱으로 시작하면 
        <br/>1~2일 내 받아볼 수 있는 사진과 기본 패키지를
        <br/> 무료로 신청할 수 있어요
      </SmallText>
      <DownloadBoxContainer>
        <DownloadBox className="app"
          onClick={handleAppStore}
        >
          <DownloadLogo>
            <Img src="/images/newLanding/home/appstore.png"/>
          </DownloadLogo>
          APP STORE
        </DownloadBox>
        <DownloadBox 
          className="googleButton"
          onClick={handleGoogle}
          >
          <DownloadLogo>
            <Img src="/images/newLanding/home/googleplay.png"/>
          </DownloadLogo>
          GOOGLE PLAY
        </DownloadBox>
      </DownloadBoxContainer>
    </Container>
  )
};

export default Cta;

const Container = styled.div`
  width: 100%;
  background-color: #f0Ede7;
  /* min-height: 100vh; */
`;

const Img = styled.img`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  margin: 55px 20px 0px;

`;

const SmallText = styled.div`
  font-size: 16px;
  margin: 30px 20px;
  line-height: 1.4;
`;

const DownloadBoxContainer = styled.div`
  margin: 0 20px 60px;
  width: 330px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DownloadBox = styled.button`
  margin-top: 10px;
  height: 50px;
  border: 1px solid  black;
  border-radius: 5px;
  &.app{
    font-size: 14px;
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: black;
    background-color: #f0Ede7;
  }
  &.googleButton{
    font-size: 14px;
    width: 170px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: black;
    background-color: #f0Ede7;
  }
`;

const DownloadLogo = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;